import { jeact } from "../../decorators/jeact";
import OY from "../../types/OY";
import { IOYSideMenuProps, menuData } from "./const";
import template from "./index.art";
import styles from "./index.module.less";

const slotObj = {
  title: "跳转至欧冶平台",
  pageUrl: window.location.origin,
  index: "95",
};

@jeact()
export default class OYSideMenu extends OY<IOYSideMenuProps> {
  static displayName = "OYSideMenu";

  $node?: {};
  roleId: number | null | undefined;
  setNode(): void {}

  /** 数据存储 */
  public state: any = {
    /** tab默认选中 */
    currIndex: 0,
    /** 是否隐藏 Popover*/
    isHidePopover: false,
    /** 菜单数据 */
    dataTop: [],
    /** 是否是tab切换*/
    isTab: false,
    /** tab切换标题 */
    tabTitle: [],
    /** 底部数据 */
    dataBottom: [],
    /** 当前选中菜单id */
    menuid: null,
    /** slot */
    slotObj: null,
    /** 折叠的菜单 */
    defaultFolds: [],
    /** 角色信息 */
    roleList: [],
    /** 显示角色id */
    roleId: null,
    /** 是否显示遮罩引导 */
    roleGuideStatus:false,
    /**引导文字 */
    roleGuideText:"",
    /**展示角色列表 */
    showRoleList:false
  };

  /** 查询url参数 */
  getUrlParam(name: string) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; //返回参数值
  }

  componentDidMount() {
    this.getSideMenu();
  }

  /** 获取菜单数据 */
  getSideMenu() {
    const _that = this;
    // const isHidePopover = localStorage.getItem("IS_HIDE_POPOVER");
    /** 获取tab默认选中的index */
    // const tabCurrIndex = sessionStorage.getItem("TAB_CURR_INDEX");
    /** 获取角色id */
    const storageRoleId = sessionStorage.getItem("SIDE_MENU_ROLE_ID");
    /** 获取遮罩状态 */
    const isHideGuide = localStorage.getItem("IS_HIDE_ROLE_GUIDE");
    let guideText = "";
    let guideFlag = false;
    let webType = "";
    if (
      this.props.webType === null ||
      this.props.webType === undefined ||
      this.props.webType === ""
    ) {
      if (
        _that.getUrlParam("webType") !== null &&
        _that.getUrlParam("webType") !== undefined &&
        _that.getUrlParam("webType") !== ""
      ) {
        webType = _that.getUrlParam("webType") ?? "";
      }
    } else {
      webType = this.props.webType;
    }
    const formData = new FormData();
    formData.append("webType", webType ?? "");
    formData.append("menuUrlId", _that.getUrlParam("menuUrlId") ?? "");
    formData.append("roleId", storageRoleId ? storageRoleId : "");
    $.ajax({
      url: "/account-ng/userVue/queryUserMenu",
      async: false,
      type: "post",
      dataType: "json",
      contentType: false,
      processData: false,
      data: formData,
      success(res) {
        const {
          tabList,
          buyerList,
          singleList,
          sellerList,
          otherList,
          roleList,
          defaultOpeneds,
        } = res;
        /** 菜单数据 */
        let dataTopArray = [];

        if (tabList.length > 1) {
          // newCurrIndex = tabCurrIndex ? Number(JSON.parse(tabCurrIndex)) : 0;
          dataTopArray = [
            _that.filterData(buyerList),
            _that.filterData(sellerList),
          ];
        } else {
          dataTopArray =
            buyerList.length > 0
              ? [_that.filterData(buyerList)]
              : [_that.filterData(singleList)];
        }
        /** 获取url参数 menuUrlId */
        const menuUrlId = _that.getUrlParam("menuUrlId") || null;
        /**
         * 根据 menuUrlId 为真并且tabList.length > 1来判断tab切换选中的值
         */
        let newCurrIndex = 0; /** tab默认选中 */
        if (menuUrlId && tabList.length > 1) {
          if (_that.findIdIsTrue(String(menuUrlId), dataTopArray[0])) {
            newCurrIndex = 0;
          }
          if (_that.findIdIsTrue(String(menuUrlId), dataTopArray[1])) {
            newCurrIndex = 1;
          }
        }

        // 当为双角色且缓存非隐藏且菜单顶部tab的index为第一个时
        if ( roleList && roleList.length > 1 && !isHideGuide && newCurrIndex == 0){
          //渲染透明遮罩
          let transparentCoverDom = document.querySelector('.transparentCover');
          if(!transparentCoverDom){
            _that.createTransparentCover();
          }
          //遮罩是否显示
          guideFlag = true ;
          //当前角色id为93或者缓存不存在角色id，默认提示仓储服务商，否则为买家。货主
          if(!storageRoleId || storageRoleId == '93'){
            guideText = '仓储服务商'
          }else {
            guideText = '买家 · 货主'
          }
        }

        _that.setState({
          ..._that.state,
          slotObj:
            webType === "VIP" ||
            webType === "GYL" ||
            webType === "XBJ" ||
            webType === "CATTLEMAN"
              ? slotObj
              : null,
          isTab: tabList.length > 1,
          tabTitle: tabList,
          dataBottom: otherList,
          dataTop: dataTopArray,
          roleList: (roleList && roleList.length > 1) ? roleList : [],
          menuid: menuUrlId,
          // isHidePopover: isHidePopover ? JSON.parse(isHidePopover) : false,
          isHidePopover: false,
          defaultFolds: defaultOpeneds || [],
          currIndex: newCurrIndex,
          roleId: storageRoleId ? storageRoleId
            : ((roleList && roleList.length > 0) ? roleList[0].id : ''),
          roleGuideStatus: guideFlag,
          roleGuideText: guideText,
          showRoleList:false
        });
      },
      error(err) {
        console.log("接口失败", err);
      },
    });
  }

  /** li点击事件 */
  bindLiClick() {
    /** tabTitleList */
    this.$class("tabList").click((event) => {
      /** 非tab切换 - 跳转 */
      if (!this.state.isTab) {
        const url = $(event.target).attr("data-url");
        if (url) {
          window.location.href = url;
        }
        return;
      }
      const _that = this;
      const index = $(event.target).attr("data-index");
      this.setState(
        {
          ...this.state,
          currIndex: Number(index),
        },
        () => {
          sessionStorage.setItem("TAB_CURR_INDEX", JSON.stringify(index));
        }
      );
    });

    /**  li */
    this.$class("li:has(ul)").click((event) => {
      const level = $(event.target).attr("data-level");
      /**
       * 判断level是否为真
       *     真 ： li
       *     假 ： span
       */
      // span
      if (!level) {
        const li = $(event.target).closest("li");
        const url = li.attr("data-url");
        const isJump = li.attr("data-isJump");
        const webType = li.attr("data-webType");
        if (!!url && isJump === "false") {
          if (webType) {
            window.location.href = `${url}&webType=${webType}`;
          } else {
            window.location.href = url;
          }
        }
        /** 折叠功能 */
        const i = $(li).find("i");
        const iconState = i.attr("data-state"); /** 初始状态 */
        const unfold = i.attr("data-unfold"); /** 是否展开 */
        if (iconState === "up") {
          if (unfold === "1") {
            $(li).find("ul").slideUp(300);
            $(i).attr("data-unfold", "0");
            i.removeClass(styles.iconUp1).addClass(styles.iconDown);
          } else {
            $(li).find("ul").slideDown(300);
            $(i).attr("data-unfold", "1");
            i.removeClass(styles.iconDown).addClass(styles.iconUp1);
          }
        }
        if (iconState === "down") {
          if (unfold === "1") {
            $(li).find("ul").slideUp(300);
            $(i).attr("data-unfold", "0");
            i.removeClass(styles.iconDown).addClass(styles.iconUp);
          } else {
            $(li).find("ul").slideDown(300);
            $(i).attr("data-unfold", "1");
            i.removeClass(styles.iconUp).addClass(styles.iconDown);
          }
        }
      }
      //li
      if (level) {
        const liId = $(event.target).attr("data-id");
        const url = $(event.target).attr("data-url");
        const webType = $(event.target).attr("data-webType");
        const throwFunction = $(event.target).attr("data-throwFunction");
        /** 判断为真 抛出方法 */
        if (throwFunction) {
          const obj = this.findIdObj(liId);
          this.$emit("onThrowFunction", obj);
          return;
        }
        if (url) {
          if (webType) {
            window.location.href = `${url}&webType=${webType}`;
          } else {
            window.location.href = url;
          }
        }
      }
    });

    /** slot */
    this.$class("slot").click((event) => {
      const url = $(event.target).attr("data-url");
      if (url) {
        window.location.href = url;
      }
    });

    /** Bottom */
    this.$class("bottom").click((event) => {
      const url = $(event.target).attr("data-url");
      const webType = $(event.target).attr("data-webType");
      if (url) {
        if (webType) {
          window.location.href = `${url}&webType=${webType}`;
        } else {
          window.location.href = url;
        }
      }
    });
  }

  /** 回调事件 */
  bindFunction() {
    /** 角色切换 */

    let timer = null
    if (timer) {
      clearTimeout(timer)
    }
    timer =setTimeout(()=>{
      this.$class("roleObjAll").hover(
        () => {
            this.setState({
              ...this.state,
              showRoleList: true,
            });
        },
        () => {
            this.setState({
              ...this.state,
              showRoleList: false,
            });
        }
    )
  } ,100)
    this.$class("switchRole").click((event) => {
      const roleList = this.state.roleList;
      const roleObj = roleList.filter(
        (item: { id: Number }) => item.id ==  $(event.target).attr("data-id")
      )[0];
      sessionStorage.setItem("SIDE_MENU_ROLE_ID", roleObj.id);
      this.$emit("onChangeRole", roleObj);
      this.getSideMenu();
      return false
    });
    /** popover关闭 */
    this.$class("closePopoverIcon").click((event) => {
      const id = $(event.target).closest("li").attr("data-id");
      const isStopProp = $(event.target).attr("stop-prop");//是否停止冒泡
      const obj = this.findIdObj(id);
      this.$emit("onClosePopover", obj);
      this.setState({
        ...this.state,
        isHidePopover: true,
      });
      // 关闭popover本地存储一个值，之后进入页面不展示popover
      // localStorage.setItem("IS_HIDE_POPOVER", JSON.stringify(true)); // 存
      const formData = new FormData();
      formData.append("closeTheGuide", "1");
      // 点击关闭调取接口，后端设置每个账号登陆就会弹出一次，下次登录再会弹出
      $.ajax({
        url: "/account-ng/user/closeTheGuide",
        async: false,
        type: "post",
        dataType: "json",
        contentType: false,
        processData: false,
        data: formData,
        success(res) {},
        error(err) {
          console.log("接口失败", err);
        },
      });
      isStopProp && event.stopPropagation();
    });

    /** 关闭遮罩引导 */
    this.$class(styles.closeRoleGuide).click((event) => {
      //移除透明遮罩
      this.removeTransparentCover();
      //修改遮罩显示状态
      this.setState({
        ...this.state,
        roleGuideStatus: false,
      });
      //设置缓存
      localStorage.setItem("IS_HIDE_ROLE_GUIDE",JSON.stringify(true))
    })
  }

  countLabelLength(str: string) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
      var a = str.charAt(i);
      a.match(/[^\x00-\xff]/gi) != null ? (len += 2) : (len += 1);
    }
    return len;
  }

  /** 递归 根据id匹配是否存在 */
  public findIdIsTrue(id: string, arrData: menuData[]) {
    let isTrue = false;
    const fun = (arr: menuData[]) => {
      arr.forEach((item) => {
        const children = item.subMenuList;
        if (item.index === id) {
          isTrue = true;
          return;
        }
        if (children) {
          fun(children);
        }
      });
    };
    fun(arrData);
    return isTrue;
  }

  /** 递归 根据id查找对应的对象 */
  public findIdObj(id: string) {
    const data = this.state.dataTop.flat();
    let obj = {};
    const fun = (arr: menuData[]) => {
      arr.forEach((item) => {
        const children = item.subMenuList;
        if (item.index === id) {
          obj = item;
          return;
        }
        if (children) {
          fun(children);
        }
      });
    };
    fun(data);
    return obj;
  }

  /** 递归 过滤 */
  public filterData(arr: menuData[]) {
    const newArr = arr
      .filter((item) => item.resourceType == 1 || item.resourceType == 2)
      .filter((item) => item.index !== "9")
      .filter((item) => typeof item.hidden !== "boolean" && !item.hidden)
      .filter(
        (item) => typeof item.isVisible === "number" && item.isVisible === 1
      );
    return newArr.map((item) => {
      if (item.subMenuList) {
        item.subMenuList = this.filterData(item.subMenuList);
      }
      return item;
    });
  }

  /**创建透明遮罩 */
  public createTransparentCover() {
    let transparentCoverDom = document.createElement('div');
    transparentCoverDom.className = 'transparentCover';
    transparentCoverDom.style.height = '100vh';
    transparentCoverDom.style.width = '100vw';
    transparentCoverDom.style.position = 'fixed';
    transparentCoverDom.style.top = '0px';
    transparentCoverDom.style.zIndex = '199999998';
    document.documentElement.appendChild(transparentCoverDom);
  }
  /**移除透明遮罩 */
  public  removeTransparentCover() {
    let transparentCoverDom = document.querySelector('.transparentCover');
    if(transparentCoverDom){
      document.documentElement.removeChild(transparentCoverDom);
    }
  }
  render() {
    return template({
      state: this.state,
      styles,
      countLabelLength: this.countLabelLength,
      roleId: this.state.roleId,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/OYSideMenu/index.ts